<script lang="ts">
import "@/style/components/TitleAndDescription.scss";
import { LocalApplicationResult } from "@/types/front/LocalApplicationResult";
import { BIcon, BTooltip } from "buefy";
import { PropType } from "vue";
export default {
  name: "TitleAndDescription",
  components: { BIcon, BTooltip },
  props: {
    application: {
      type: Object as PropType<LocalApplicationResult>,
      default: null,
    },
    localName: {
      type: String,
      default: "",
    },
    localDescription: {
      type: String,
      default: "",
    },
    localTitle: {
      type: String,
      default: "",
    },
    applicationName: {
      type: String,
      default: "",
    },
    withAuth: {
      type: Boolean,
    },
    canCreateApplication: {
      type: Boolean,
    },
    canManagerApplication: {
      type: Boolean,
    },
    canManagerUser: {
      type: Boolean,
    },
  },
};
</script>

<template>
  <h1 class="title main-title">
    <slot
      name="label"
      :option="application"
      :aria-label="localTitle || localName"
    >
      {{ localTitle || localName }}
    </slot>
    <slot
      v-if="localDescription"
      name="description"
      :option="application"
      :aria-label="localDescription"
    >
      <sup class="iconSup">
        <b-tooltip
          :label="$t('applications.description') + localDescription"
          :aria-label="$t('applications.description') + localDescription"
          position="is-top"
        >
          <b-icon
            icon="info-circle"
            type="is-dark"
          />
        </b-tooltip>
      </sup>
    </slot>
  </h1>
</template>
